import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BackHandler, StyleSheet, View } from 'react-native';
import { useRecoilState } from 'recoil';

import { alertsTestIDs, Theme } from '@constants';
import { helpers } from '@helpers';
import { useContextNodeHandle } from '@hooks';
import { navigationService } from '@services';
import { screenReaderEnabledState } from '@store';

import { TWCButton } from '../../focusable/TWCButton/TWCButton';
import { TWCTileContent } from '../../focusable/TWCTileContent/TWCTileContent';
import { TWCText } from '../../primitives/TWCText/TWCText';

const tPath = 'alerts.exit';

const closeApp = () => {
  if (helpers.isTizen) {
    window.tizen.application.getCurrentApplication().exit();
  } else if (helpers.isX1) {
    $badger.shutdown();
  } else if (helpers.isVizio) {
    window.VIZIO.exitApplication();
    if (helpers.DEBUG) {
      window.location.href = window.VIZIO.debugBaseURL;
    }
  } else {
    BackHandler.exitApp();
  }
};

export const AlertExit: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: tPath });
  const [screenReaderEnabled] = useRecoilState(screenReaderEnabledState);

  const noButtonHandle = useContextNodeHandle(alertsTestIDs.exit.buttonNo);
  const yesButtonHandle = useContextNodeHandle(alertsTestIDs.exit.buttonYes);

  useEffect(() => {
    if (helpers.isWeb) {
      setTimeout(() => {
        helpers.FOCUS_NOW(noButtonHandle);
      }, 10);
    }
  }, [noButtonHandle]);

  return (
    <TWCTileContent height={457} width={674}>
      <View accessibilityRole={'text'} accessible={screenReaderEnabled} style={styles.alertModalContent}>
        <TWCText style={styles.titleText} testID={alertsTestIDs.exit.headlineText} variant={'regularText36'}>
          {t('headingText')}
        </TWCText>
        <TWCButton
          accessibilityHint={t('noButtonAccessibilityHint')}
          accessibilityLabel={t('noButtonAccessibilityLabel')}
          nextFocusDown={yesButtonHandle}
          nextFocusLeft={null}
          nextFocusRight={null}
          nextFocusUp={null}
          style={styles.noButton}
          testID={alertsTestIDs.exit.buttonNo}
          title={t('noButtonText')}
          onPress={() => {
            navigationService.goBack();
          }}
        />
        <TWCButton
          accessibilityHint={t('yesButtonAccessibilityHint')}
          accessibilityLabel={t('yesButtonAccessibilityLabel')}
          nextFocusDown={null}
          nextFocusLeft={null}
          nextFocusRight={null}
          nextFocusUp={noButtonHandle}
          style={styles.yesButton}
          testID={alertsTestIDs.exit.buttonYes}
          title={t('yesButtonText')}
          onPress={closeApp}
        />
      </View>
    </TWCTileContent>
  );
};

const styles = StyleSheet.create({
  alertModalContent: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: Theme.px(90),
  },
  card: {
    alignItems: 'center',
    flex: 1,
  },
  noButton: {
    marginTop: Theme.px(54),
  },
  titleText: {
    lineHeight: Theme.px(48),
    textAlign: 'center',
  },
  yesButton: {
    marginTop: Theme.px(15),
  },
});
